import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { BrandProvider } from "@/context/BrandContext";
import Login from "@/pages/Login";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Ingredients from "@/pages/Ingredients";
import Recipes from "@/pages/Recipes";
import Labels from "@/pages/Labels";
import Invoices from "@/pages/Invoices";
import Settings from "@/pages/Settings";
import RecipeSheet from "@/pages/RecipeSheet";
import MenuExport from "@/pages/MenuExport";
import { Loader2 } from "lucide-react";

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Loader2 className="w-8 h-8 animate-spin text-primary" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  return children;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrandProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route
                path="/scheda/:id"
                element={
                  <ProtectedRoute>
                    <RecipeSheet />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/menu"
                element={
                  <ProtectedRoute>
                    <MenuExport />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <Layout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<Dashboard />} />
                <Route path="ingredienti" element={<Ingredients />} />
                <Route path="ricette" element={<Recipes />} />
                <Route path="etichette" element={<Labels />} />
                <Route path="fatture" element={<Invoices />} />
                <Route path="impostazioni" element={<Settings />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </BrandProvider>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
